import camelcaseKeys from 'camelcase-keys';
import SummaryReportsAPI from 'dashboard/api/summaryReports';

export const initialState = {
  agentSummaryReports: [],
  uiFlags: {
    isFetchingAgentSummaryReports: false,
  },
};

export const getters = {
  getAgentSummaryReports(state) {
    return state.agentSummaryReports;
  },
  getUIFlags(state) {
    return state.uiFlags;
  },
};

export const actions = {
  async fetchAgentSummaryReports({ commit }, params) {
    commit('setUIFlags', { isFetchingAgentSummaryReports: true });
    try {
      const response = await SummaryReportsAPI.getAgentReports(params);
      commit(
        'setAgentSummaryReports',
        camelcaseKeys(response.data, { deep: true })
      );
    } finally {
      commit('setUIFlags', { isFetchingAgentSummaryReports: false });
    }
  },
};

export const mutations = {
  setAgentSummaryReports(state, data) {
    state.agentSummaryReports = data;
  },
  setUIFlags(state, uiFlags) {
    state.uiFlags = { ...state.uiFlags, ...uiFlags };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
